import { useContext } from "react";

import { DispatchContext } from "App";
import { Roles } from "utils/auth";

export const useRole = (): Roles | undefined => {
  const { state } = useContext(DispatchContext);
  return state.role;
};
